import { ALL_TEXT, Group, GroupType } from './Group';



export class ServerUser {
  id: number  = -1;
  username: string = "";
  name: string = "";
  phone: string = "";
  isAdmin: boolean = false;
  role: UserRole = 'User';
  permissions: string[] = [];
  isActive: UserStatus = UserStatus.Inactive;
  printCount: number = 0;
  printRequestCount: number = 0;
  groupName: string  = ALL_TEXT;
  groupId: number | null = -1;
  groupType?: GroupType;
  voiceAccessEnabled: boolean = true;
  group?: Group | null;
}

export type UserRole = 'User' | 'Admin' | 'SuperAdmin';

export enum UserStatus
{
    Inactive = 0,
    Active = 1
 }


export class User {
  id: number  = -1;
  username: string = "";
  name: string = "";
  phone: string = "";
  isAdmin: boolean = false;
  role: UserRole = 'User';
  permissions: string[] = [];
  isActive: UserStatus = UserStatus.Inactive;
  printCount: number = 0;
  printRequestCount: number = 0;
  group: Group | null = null;
  voiceAccessEnabled: boolean = true;
  
  constructor(user: ServerUser) {
    this.id = user.id;
    this.username = user.username;
    this.name = user.name;
    this.phone = user.phone;
    this.role = normalizeUserRole(user.role);
    this.permissions = user.permissions ?? [];
    this.isAdmin =
      user.isAdmin === true ||
      this.role === 'Admin' ||
      this.role === 'SuperAdmin';
    this.isActive = user.isActive;
    this.printCount = user.printCount;
    this.printRequestCount = user.printRequestCount;
    const voiceAccess = user.voiceAccessEnabled ?? (user as any).VoiceAccessEnabled;
    this.voiceAccessEnabled = voiceAccess !== false;
    if (user.group) {
      const type = user.group.type ?? (user.group.IsHub ? 'Hub' : 'Standard');
      this.group = new Group(user.group.id, user.group.name, type);
    } else if (user.groupId != null && user.groupId >= 0) {
      this.group = new Group(user.groupId, user.groupName, user.groupType);
    } else {
      this.group = null;
    }
  }

}

function normalizeUserRole(role: UserRole | number | string | undefined | null): UserRole {
  if (role === 'Admin' || role === 'SuperAdmin' || role === 'User') return role;
  if (role === 2 || role === '2') return 'SuperAdmin';
  if (role === 1 || role === '1') return 'Admin';
  return 'User';
}
